import _ from 'underscore';
import Backbone from 'backbone';
import tpl from './starter-guide-template.hbs';

var StarterGuideView = Backbone.View.extend({
  tagName: 'div',

  template: tpl,

  events: {
    'click [data-starter-click=close]': 'hide'
  },

  initialize: function () {
    this.ready = false;
    this.unregShowDownload = _.noop;
  },

  render: function () {
    this.$el.html(this.template());
    return this;
  },

  registerShowDownload: function () {
    this.unregShowDownload();

    this.$('.starter-loading').show();
    this.$('.starter-download').hide();

    this.unregShowDownload = _.delayed(
      _.bind(function () {
        this.$('.starter-loading').hide();
        this.$('.starter-download').show();
      }, this),
      1000 * 15
    ); // 15초 후에 다운로드 버튼 표시
  },

  show: function () {
    if (this.ready) {
      this.$('.starter-guide-non-ie').show();
    } else {
      $('body').append(this.render().el);
      this.$('.starter-guide-non-ie').show();
      this.ready = true;
    }

    this.registerShowDownload();
  },

  hide: function () {
    this.$('.starter-guide-non-ie').hide();
  }
});

export var starterGuide = new StarterGuideView();
